export default "__VITE_ASSET__jPpcN380__"